export default "__VITE_ASSET__BPSbP3IS__"